import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isWalletOpen: false,
};

const connectWalletSlice = createSlice({
  name: 'walletModal',
  initialState,
  reducers: {
    setOpenWalletModal: (state, action) => {
      state.isWalletOpen = action.payload;
    },
  }
})

export const { setOpenWalletModal } =connectWalletSlice.actions;
export const currentWalletState = (state) => state.walletModal.isWalletOpen;
export default connectWalletSlice.reducer;